import { Checkbox } from '@volkswagen-onehub/components-core';
import React from 'react';
import { getTranslations } from '../../../../translations';

const IncludeTax = ({taxHandler, checked} : {taxHandler : () => void, checked : boolean}) => {
    const trans = getTranslations();

    return <Checkbox label={trans.details.calculator.payment_includeSalesTax} value="includeTax" onClick={taxHandler} checked={checked} />;
}

export default IncludeTax;